// Module
var code = " <configurable-grid-form-view config=\"progressiveMachinesController.configurableGridFormViewConfig\"> </configurable-grid-form-view> ";
// Exports
export default code;